import { createFileRoute, redirect } from "@tanstack/react-router";

// The Chinese on-demand webinar was made Chinese-only (lang: zh-cn), so its
// former English URL no longer resolves. Permanent redirect from the retired
// English URL to the English equivalent on-demand recording, thrown from
// beforeLoad so SSR answers with a real HTTP redirect.
export const Route = createFileRoute(
  "/en/webinars/webinar-on-demand-entering-the-european-medtech-market-chinese",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/en/webinars/$slug",
      params: {
        slug: "webinar-on-demand-entering-the-european-medtech-market-why-one-approval-doesnt-fit-all",
      },
      replace: true,
      statusCode: 301,
    });
  },
});
